import React, { useEffect } from "react";
import {
  Box,
} from "@chakra-ui/react";
import CustomTable from "../components/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { clearsearchFilter } from "../redux/slices/searchFilterSlice";
import { fetchUsers } from "../redux/slices/usersSlice";

const UserTypeTable = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(clearsearchFilter());
  }, [dispatch]);

  const usersTable = useSelector((state) => state?.users);
  console.log(usersTable);

  // await dispatch(setUserTypeDetails(item));

  // const handleEdit = async (item) => {
  //   dispatch(
  //     setFormModal({
  //       status: true,
  //       title: "Edit Membership Type",
  //       type: "editMembershipType",
  //     })
  //   );
  //   await dispatch(setEditType(item));
  // };

  // const handleDeactivate = async (item) => {
  //   dispatch(
  //     setConfirmModal({
  //       status: true,
  //       type: "deactivateMembershipType",
  //       title: item.isActive ? "Deactivate " : "Activate",
  //       desc: item.isActive
  //         ? `Are you sure you want to deactivate MembershipType ${item.name}?`
  //         : `Are you sure you want to activate ${item.name}?`,
  //       buttonText: item.isActive
  //         ? `Yes, Deactivate ${item.name}`
  //         : `Yes, Activate ${item.name}`,
  //       payload: item,
  //     })
  //   );
  // };

  // const handleDelete = async (item) => {
  //   // console.log("Delete item",item);

  //   try {
  //     await httpRequest(`${BASE_URL}/MembershipType/delete/${item.id}`, "post");

  //     await dispatch(fetchMembershipType());
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const formatAmount = (amount) => {
  //   return new Intl.NumberFormat("en-NG", {
  //     style: "currency",
  //     currency: "NGN",
  //   }).format(amount);
  // };

  const tableProps = {
    data: usersTable?.data,
    title: {
      email: "Email",
      phoneNumber: "Phone Number",
      firstName: "First Name",
      lastName: "Last Name",
      roleNames: "Role Names",
    },
    dataKeys: ["email", "phoneNumber", "firstName", "lastName", "roleNames"],
    variant: true,

    transformRow: (item) => ({
      email: <div>{item?.email}</div>,

      phoneNumber: <div>{item?.phoneNumber}</div>,
      firstName: <div>{item?.firstName}</div>,
      lastName: <div>{item?.lastName}</div>,
      roleNames: <div>{item?.roles.toString()}</div>,
      // Action: (
      //   <Menu>
      //     <MenuButton>
      //       <BsThreeDotsVertical />
      //     </MenuButton>

      //     <MenuList>
      //        <MenuItem onClick={() => handleEdit(item)}>Edit</MenuItem>
      //       <MenuItem onClick={() => handleDeactivate(item)}>
      //         {item?.isActive ? "Deactivate" : "Activate"}
      //       </MenuItem>
      //       <MenuItem onClick={() => handleDelete(item)}>Delete</MenuItem>
      //     </MenuList>
      //   </Menu>
      // ),
    }),
  };
  return (
    <Box my={4}>
      {usersTable?.data?.length > 0 && (
        <CustomTable {...tableProps} sn={false} />
      )}
    </Box>
  );
};

export default UserTypeTable;
